"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types;
(function (Types) {
    let CourseStates;
    (function (CourseStates) {
        CourseStates["ACTIVE"] = "ACTIVE";
        CourseStates["SUSPENDED"] = "SUSPENDED";
    })(CourseStates = Types.CourseStates || (Types.CourseStates = {}));
    let CourseWorkStates;
    (function (CourseWorkStates) {
        CourseWorkStates["ACTIVE"] = "ACTIVE";
        CourseWorkStates["INACTIVE"] = "INACTIVE";
        CourseWorkStates["PROVISIONED"] = "PROVISIONED";
        CourseWorkStates["COURSE_STATE_UNSPECIFIED"] = "COURSE_STATE_UNSPECIFIED";
    })(CourseWorkStates = Types.CourseWorkStates || (Types.CourseWorkStates = {}));
    let SubmissionStates;
    (function (SubmissionStates) {
        SubmissionStates["INACTIVE"] = "INACTIVE";
        SubmissionStates["NEW"] = "NEW";
        SubmissionStates["CREATED"] = "CREATED"; // has been created
    })(SubmissionStates = Types.SubmissionStates || (Types.SubmissionStates = {}));
    let AssigneeModes;
    (function (AssigneeModes) {
        AssigneeModes["ALL_STUDENTS"] = "ALL_STUDENTS";
        AssigneeModes["INDIVIDUAL_STUDENTS"] = "INDIVIDUAL_STUDENTS";
    })(AssigneeModes = Types.AssigneeModes || (Types.AssigneeModes = {}));
    let UserAuthProviders;
    (function (UserAuthProviders) {
        UserAuthProviders["GOOGLE"] = "google";
        UserAuthProviders["EMAIL"] = "email";
    })(UserAuthProviders = Types.UserAuthProviders || (Types.UserAuthProviders = {}));
    let CreationModes;
    (function (CreationModes) {
        CreationModes["GOOGLE_CLASSROOM"] = "GOOGLE_CLASSROOM";
        CreationModes["MANUAL"] = "MANUAL"; // Manually Via the Application
    })(CreationModes = Types.CreationModes || (Types.CreationModes = {}));
    let ContentTypes;
    (function (ContentTypes) {
        ContentTypes["PROGRAM"] = "programTypes";
        ContentTypes["ACTIVITY"] = "activityTypes";
        ContentTypes["ITEM"] = "itemTypes";
        ContentTypes["QUESTION"] = "questionTypes";
        ContentTypes["VIRTUALGOODS"] = "virtualGoodTypes";
    })(ContentTypes = Types.ContentTypes || (Types.ContentTypes = {}));
    let ContentIndices;
    (function (ContentIndices) {
        ContentIndices["PROGRAM"] = "programs";
        ContentIndices["ACTIVITY"] = "activities";
        ContentIndices["ITEM"] = "items";
        ContentIndices["QUESTION"] = "questions";
    })(ContentIndices = Types.ContentIndices || (Types.ContentIndices = {}));
    let UserPermissionRoles;
    (function (UserPermissionRoles) {
        UserPermissionRoles["SCHOOL_ADMIN"] = "SCHOOL_ADMIN";
        UserPermissionRoles["TEACHER"] = "TEACHER";
        UserPermissionRoles["STUDENT"] = "STUDENT";
    })(UserPermissionRoles = Types.UserPermissionRoles || (Types.UserPermissionRoles = {}));
    Types.BACKEND_URL = 'https://us-central1-omega-rhino-227310.cloudfunctions.net';
})(Types = exports.Types || (exports.Types = {}));
//# sourceMappingURL=Types.js.map